import React, { useState, useRef, useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import JoditEditor from "jodit-react";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";

import { Row, Col, Card, Container } from "react-bootstrap";

const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ myon, setMyon }) => {
  // const classes = useStyles();
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [inputField, setInputField] = useState(myon);
  const [displaySave, setDisplaySave] = useState(true);
  const [reasonIsRequired, setReasonIsRequired] = useState(!myon.persoom);
  const editor = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      //colorPickerDefaultTab: "background",
      //buttons: ["brush"],
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
    }),
    []
  );
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "persoom") {
      inputField.persoom = e.target.checked;
      setReasonIsRequired((prev) => !prev);
    } else {
      setInputField((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    setDisplaySave(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "myonmakdeem/" + inputField.id + "/",
          inputField,
          {
            signal: controller.signal,
          }
        );
        isMounted && setMyon(response.data);
        alert("העדכון בוצע בהצלחה");
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    if (!inputField.persoom && inputField.nemmok_ei_persoom == "") {
      alert(
        "לא ניתן לעדכן את הישיבה, חובה לספק סיבת אי פירסום אמות המידה של שלב המיון המקדים."
      );
    } else {
      saveData();
      setDisplaySave(true);
    }
  };
  if (!inputField) return null;
  return (
    <>
      <HelpModal />
      <Card className="success container px-5 " bg="light">
        <Card.Header className="mx-auto">
          <h3
            onClick={() => {
              setSaeef("25");
              setShowHelp(true);
            }}
          >
            עדכון מיון מקדים
            <span className="help">
              <MdLiveHelp />
            </span>
          </h3>
        </Card.Header>
        <Card.Body>
          <form onSubmit={handleSubmit}>
            <Container className="col-sm-10">
              <Row>
                <Col>
                  <label htmlFor="date">תאריך עריכת הישיבה </label>
                  <input
                    type="date"
                    name="date"
                    value={inputField.date}
                    onChange={handleChange}
                    className="form-control"
                    id="date"
                    placeholder=""
                  />
                </Col>
                <Col>
                  <label htmlFor="time">זמן עריכת הישיבה 1111</label>
                  <input
                    type="time"
                    name="time"
                    value={inputField.time}
                    onChange={handleChange}
                    className="form-control"
                    id="time"
                    placeholder=""
                    pattern="(2[0-3]|[01][0-9]):[0-5][0-9]"
                  />
                </Col>

                <Col>
                  <label htmlFor="mozmaneem_num">מספר המוזמנים </label>
                  <input
                    type="number"
                    name="mozmaneem_num"
                    value={inputField.mozmaneem_num}
                    onChange={handleChange}
                    className="form-control"
                    id="mozmaneem_num"
                    placeholder=""
                  />
                </Col>
                <Col>
                  <label htmlFor="tsion_saf">ציון סף</label>
                  <input
                    type="number"
                    name="tsion_saf"
                    value={inputField.tsion_saf}
                    onChange={handleChange}
                    className="form-control"
                    id="tsion_saf"
                    placeholder="מספר המשרות המוצעות"
                  />
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col className="d-flex justify-content-center">
                  <div className="form-group col-sm-8">
                    <label htmlFor="persoom">
                      האם פרטי המיון המקדים פורסמו?
                    </label>{" "}
                    <input
                      type="checkbox"
                      id="persoom"
                      name="persoom"
                      value={inputField.persoom}
                      onChange={handleChange}
                      checked={inputField.persoom}
                    />
                    <br />
                    {reasonIsRequired &&
                      "שים לב חייב לספק נימוקים לאי פרסום פרטי המיון המקדים."}
                  </div>
                </Col>
                <Col>
                  <label htmlFor="nemmok_ei_persoom">
                    {" "}
                    נימוקים לאי פירסום פרטי המיון המקדים{" "}
                  </label>
                  <textarea
                    style={{
                      width: "100%",
                      maxWidth: "500px",
                      padding: "0px",
                      margin: "5px",
                    }}
                    cols="60"
                    rows="10"
                    name="nemmok_ei_persoom"
                    value={inputField.nemmok_ei_persoom}
                    onChange={handleChange}
                    className="form-control"
                    id="nemmok_ei_persoom"
                    placeholder=""
                    required={inputField.persoom.checked}
                  />
                </Col>
              </Row>

              <Row>
                {" "}
                <Col>
                  <label htmlFor="natseeg_rosh_harashoot">
                    נציג ראש הרשות{" "}
                  </label>
                  <input
                    type="text"
                    name="natseeg_rosh_harashoot"
                    value={inputField.natseeg_rosh_harashoot}
                    onChange={handleChange}
                    className="form-control"
                    id="natseeg_rosh_harashoot"
                    placeholder=""
                  />
                </Col>
                <Col>
                  <label htmlFor="memona_mashaavi_enosh">
                    {" "}
                    ממונה משאבי אנוש
                  </label>
                  <input
                    type="text"
                    name="memona_mashaavi_enosh"
                    value={inputField.memona_mashaavi_enosh}
                    onChange={handleChange}
                    className="form-control"
                    id="memona_mashaavi_enosh"
                    placeholder=""
                  />
                </Col>
                <Col>
                  <label htmlFor="yoamash"> היועץ המשפטי</label>
                  <input
                    type="text"
                    name="yoamash"
                    value={inputField.yoamash}
                    onChange={handleChange}
                    className="form-control"
                    id="yoamash"
                    placeholder=""
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <div className="mb-2">
                    <label htmlFor="notes">הערות</label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <JoditEditor
                    editorRef={editor}
                    name="notes"
                    value={inputField.notes}
                    config={config}
                    onBlur={(newContent) => {
                      setInputField((prevState) => ({
                        ...prevState,
                        notes: newContent,
                      }));
                      //setDisplaySave(false);
                    }}
                    onChange={(newContent) => {
                      if (inputField.notes !== newContent) {
                        setDisplaySave(false);
                      }
                    }}
                  />
                </Col>
              </Row>

              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={displaySave}
                >
                  שמור
                </button>
              </div>
            </Container>
          </form>
        </Card.Body>
      </Card>
    </>
  );
};

export default Edit;
